"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module adaptive-expressions
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const expression_1 = require("./expression");
/**
 * Information on how to evaluate an expression.
 */
class ExpressionEvaluator {
    /**
     * Initializes a new instance of the <see cref="ExpressionEvaluator"/> class.
     * @param type Expression type.
     * @param evaluator Delegate to evaluate an expression.
     * @param returnType Type expected from evaluation.
     * @param validator Static validation of expression.
     */
    constructor(type, evaluator, returnType = expression_1.ReturnType.Object, validator) {
        /**
         * Evaluate an expression.
         * @param expression Expression to evaluate.
         * @param state Global state information.
         */
        this.tryEvaluate = (expression, state, options) => this._evaluator(expression, state, options);
        /**
         * Validate an expression.
         * @param expression Expression to validate.
         */
        this.validateExpression = (expression) => this._validator(expression);
        this.type = type;
        this._evaluator = evaluator;
        this.returnType = returnType;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._validator = validator || ((expr) => { });
    }
}
exports.ExpressionEvaluator = ExpressionEvaluator;
//# sourceMappingURL=expressionEvaluator.js.map